module.exports = __webpack_public_path__ + "img/暴雨@2x.f86e21d1.png";